<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <div>
        <span class="is-pulled-right">
          <a class="button mr-2" @click="exportThisPage">Export</a>
        </span>
        
        <h1 class="title">Price Analysis</h1>

        <div class="mt-3">
          <div v-if="waiting">
            <span class="icon is-medium is-size-4">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div v-else>
            <div class="columns mt-4">
              <div class="column field mb-0 pb-0">
                <p class="control has-icons-left">
                  <span class="select">
                    <select v-model="filter">
                      <option v-for="(c, i) in classOptions"  :key="'product-class-option' + i">
                        {{c}}
                      </option>
                    </select>
                  </span>
                  <span class="icon is-small is-left">
                    <i class="fas fa-filter"></i>
                  </span>
                </p>
              </div>
              <div class="column field  mb-0 pb-0">
                <p class="control has-icons-left">
                  <input class="input" type="text" placeholder="Search" v-model="search">
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </p>
              </div>
            </div>

            <div class="table-container">
              <table class="table is-fullwidth is-hoverable is-striped my-table">
                <thead>
                  <th class="is-clickable" @click="changeSortOption('parentModel')">
                    <span>Parent model</span>
                    <span class="icon" v-if="sortOption.field == 'parentModel'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable" @click="changeSortOption('model')">
                    <span>Variant model</span>
                    <span class="icon" v-if="sortOption.field == 'model'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable" @click="changeSortOption('hdLowestModel')">
                    <span>HD lowest model</span>
                    <span class="icon" v-if="sortOption.field == 'hdLowestModel'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('hdLowestPriceValue')">
                    <span>HD lowest price</span>
                    <span class="icon" v-if="sortOption.field == 'hdLowestPriceValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('hdPriceValue')">
                    <span>HD price</span>
                    <span class="icon" v-if="sortOption.field == 'hdPriceValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('hdOurPriceValue')">
                    <span>HD our price</span>
                    <span class="icon" v-if="sortOption.field == 'hdOurPriceValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('hdPremiumValue')">
                    <span>HD premium</span>
                    <span class="icon" v-if="sortOption.field == 'hdPremiumValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable" @click="changeSortOption('wfLowestModel')">
                    <span>WF lowest model</span>
                    <span class="icon" v-if="sortOption.field == 'wfLowestModel'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('wfLowestPriceValue')">
                    <span>WF lowest price</span>
                    <span class="icon" v-if="sortOption.field == 'wfLowestPriceValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('wfPriceValue')">
                    <span>WF price</span>
                    <span class="icon" v-if="sortOption.field == 'wfPriceValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('wfOurPriceValue')">
                    <span>WF our price</span>
                    <span class="icon" v-if="sortOption.field == 'wfOurPriceValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('wfPremiumValue')">
                    <span>WF premium</span>
                    <span class="icon" v-if="sortOption.field == 'wfPremiumValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('diffValue')">
                    <span>HD vs WF Diff</span>
                    <span class="icon" v-if="sortOption.field == 'diffValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                  <th class="is-clickable has-text-right" @click="changeSortOption('diffPercentageValue')">
                    <span>HD vs WF Diff %</span>
                    <span class="icon" v-if="sortOption.field == 'diffPercentageValue'">
                      <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                    </span>
                  </th>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in showingProducts" :key="'p-' + i">
                    <td>{{ p.parentModel }}</td>
                    <td>{{ p.model }}</td>
                    <td>{{ p.hdLowestModel }}</td>
                    <td class="has-text-right">{{ p.hdLowestPrice }}</td>
                    <td class="has-text-right">
                      <span class="tag" :class="{'is-warning': p.homeDepotHighMargin == 'Yes'}" v-if="p.homeDepotMarginValue">{{ p.homeDepotMarginLabel }}</span>
                      <span>{{ p.hdPrice }}</span>
                    </td>
                    <td class="has-text-right">{{ p.hdOurPrice }}</td>
                    <td class="has-text-right">{{ p.hdPremium }}</td>
                    <td>{{ p.wfLowestModel }}</td>
                    <td class="has-text-right">{{ p.wfLowestPrice }}</td>
                    <td class="has-text-right">
                      <span class="tag" :class="{'is-warning': p.wayfairHighMargin == 'Yes'}" v-if="p.wayfairMarginValue">{{ p.wayfairMarginLabel }}</span>
                      <span>{{ p.wfPrice }}</span>
                    </td>
                    <td class="has-text-right">{{ p.wfOurPrice }}</td>
                    <td class="has-text-right">{{ p.wfPremium }}</td>
                    <td class="has-text-right">{{ p.diff }}</td>
                    <td class="has-text-right">{{ p.diffPercentage }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
      
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>

    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import dateFormat from 'dateformat'

function formatPrice (value) {
  if (!value) {
    return ''
  }
  return '$' + value.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: false
  })
}

function formatPercentage (value) {
  if (!value) {
    return ''
  }
  return roundTo(value*100, 2) + '%'
}

function roundTo (value, decimals) {
  if (decimals == 0) {
    return Math.round(value)
  }
  var tens = Math.pow(10, decimals)
  return Math.round((value + Number.EPSILON) * tens) / tens
}

export default {
  name: 'PriceAnalysis',
  components: {
  },
  data () {
    return {
      error: '',
      waiting: false,
      search: '',
      filter: 'All',
      products: [],
      classOptions: [],
      search: '',
      sortOption: { field: 'parentModel', asc: true },
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    showingProducts () {
      var vm = this
      var filtered = this.products.filter(p => {
        if (vm.filter == 'All') {
          return true
        }
        return p.className == vm.filter
      }).filter(p => {
        var search = vm.search.toLowerCase()
        return p.model.toLowerCase().includes(search)
          || p.parentModel.toLowerCase().includes(search)
          || p.hdLowestModel.toLowerCase().includes(search)
          || p.wfLowestModel.toLowerCase().includes(search)
      })

      var sort = vm.sortOption
      var sorted = filtered.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (va == null || va == undefined || vb == null || vb == undefined) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }

        if (sort.field == 'model' || sort.field == 'parentModel' || sort.field == 'hdLowestModel' || sort.field == 'wfLowestModel') {
          return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
        }
        return sort.asc ? va - vb : vb - va
      })
      return sorted
    },
  },
  watch: {
    filter: function (val) {
    },
  },
  methods: {
    getProducts () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-price-analysis-dashboard/').then(resp => {
        this.products = resp.body.map(i => this.makeProduct(i))
        var classNames = new Set()
        this.products.forEach(p => classNames.add(p.className))
        this.classOptions = [...classNames]
        this.classOptions.sort((a, b) => a.localeCompare(b))
        this.classOptions.unshift('All')
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    makeProduct (item) {
      var parentModel = item.hdLowest.parentModel || item.wfLowest.parentModel || ''
      var hdLowestModel = item.hdLowest.lowestModel
      var model = item.model
      var hdLowestPriceValue = item.hdLowest.lowestPrice || 0
      var hdLowestPrice = formatPrice(hdLowestPriceValue)
      var hdPriceValue = item.hdPrice || 0
      var hdPrice = formatPrice(hdPriceValue)
      var hdOurPriceValue = this.getOurPrice(item, 'homeDepot') || 0
      var hdOurPrice = formatPrice(hdOurPriceValue)
      var hdPremiumValue = (hdPriceValue && hdLowestPriceValue) ? ((hdPriceValue - hdLowestPriceValue) / hdLowestPriceValue) : 0
      var hdPremium = formatPercentage(hdPremiumValue)
      var homeDepotLowestPriceValue = 0
      var homeDepotMarginValue = null
      var homeDepotMarginLabel = ''
      var homeDepotHighMargin = ''
      if (item.homeDepotData) {
        var homeDepotData = JSON.parse(item.homeDepotData)
        var homeDepotWholesalePrice = homeDepotData.homeDepotWholesalePrice
        if (homeDepotWholesalePrice) {
          homeDepotLowestPriceValue = homeDepotWholesalePrice.price
        }
        if (homeDepotLowestPriceValue && homeDepotData.homeDepotPromotionPercentage && (homeDepotData.homeDepotPromotionPercentage.percentage || homeDepotData.homeDepotPromotionPercentage.price)) {
          var homeDepotPromotion = homeDepotData.homeDepotPromotionPercentage
          var homeDepotPromotionPrice = 0
          if (homeDepotPromotion.percentage) {
            homeDepotPromotionPrice = homeDepotLowestPriceValue * (1 - (homeDepotPromotion.percentage / 100))
          } else if (homeDepotPromotion.price) {
            homeDepotPromotionPrice = homeDepotPromotion.price
          }
          if (homeDepotLowestPriceValue > homeDepotPromotionPrice) {
            homeDepotLowestPriceValue = homeDepotPromotionPrice
          }
        }
        var homeDepotFreight = homeDepotData.freightCost
        if (homeDepotFreight && homeDepotLowestPriceValue && hdPriceValue) {
          homeDepotMarginValue = (hdPriceValue - homeDepotLowestPriceValue - homeDepotFreight) / hdPriceValue
          homeDepotMarginLabel = formatPercentage(homeDepotMarginValue)
          homeDepotHighMargin = homeDepotMarginValue > 0.2 ? 'Yes' : 'No'
        }
      }
      var wfLowestModel = item.wfLowest.lowestModel
      var wfLowestPriceValue = item.wfLowest.lowestPrice || 0
      var wfLowestPrice = formatPrice(wfLowestPriceValue)
      var wfPriceValue = item.wfPrice || 0
      var wfPrice = formatPrice(wfPriceValue)
      var wfOurPriceValue = this.getOurPrice(item, 'wayfair') || 0
      var wfOurPrice = formatPrice(wfOurPriceValue)
      var wfPremiumValue = (wfPriceValue && wfLowestPriceValue) ? ((wfPriceValue - wfLowestPriceValue) / wfLowestPriceValue) : 0
      var wfPremium = formatPercentage(wfPremiumValue)
      var wayfairMarginValue = null
      var wayfairMarginLabel = ''
      var wayfairHighMargin = ''
      var wayfairLowestPriceValue = 0
      if (item.wayfairData) {
        var wayfairData = JSON.parse(item.wayfairData)
        var wayfairWholesalePrice = wayfairData.wayfairWholesalePrice
        if (wayfairWholesalePrice) {
          wayfairLowestPriceValue = wayfairWholesalePrice.price
        }
        if (wayfairLowestPriceValue && wayfairData.wayfairPromotionPercentage && (wayfairData.wayfairPromotionPercentage.percentage || wayfairData.wayfairPromotionPercentage.price)) {
          var wayfairPromotion = wayfairData.wayfairPromotionPercentage
          var wayfairPromotionPrice = 0
          if (wayfairPromotion.percentage) {
            wayfairPromotionPrice = wayfairLowestPriceValue * (1 - (wayfairPromotion.percentage / 100))
          } else if (wayfairPromotion.price) {
            wayfairPromotionPrice = wayfairPromotion.price
          }
          if (wayfairLowestPriceValue > wayfairPromotionPrice) {
            wayfairLowestPriceValue = wayfairPromotionPrice
          }
        }
        var wayfairFreight = wayfairData.freightCost
        if (wayfairFreight && wayfairLowestPriceValue && wfPriceValue) {
          wayfairMarginValue = (wfPriceValue- wayfairLowestPriceValue - wayfairFreight) / wfPriceValue
          wayfairMarginLabel = formatPercentage(wayfairMarginValue)
          wayfairHighMargin = wayfairMarginValue > 0.2 ? 'Yes' : 'No'
        }
      }
      var diffValue = hdPriceValue - wfPriceValue
      var diff = formatPrice(diffValue)
      var diffPercentageValue = hdPriceValue ? (diffValue / hdPriceValue) : 0
      var diffPercentage = formatPercentage(diffPercentageValue)
      return {
        id: item.id,
        className: item.productClass,
        parentModel: parentModel,
        hdLowestModel: hdLowestModel,
        model: model,
        hdLowestPriceValue: hdLowestPriceValue,
        hdLowestPrice: hdLowestPrice,
        hdPriceValue: hdPriceValue,
        hdPrice: hdPrice,
        hdOurPriceValue: hdOurPriceValue,
        hdOurPrice: hdOurPrice,
        hdPremiumValue: hdPremiumValue,
        hdPremium: hdPremium,
        homeDepotMarginValue: homeDepotMarginValue,
        homeDepotMarginLabel: homeDepotMarginLabel,
        homeDepotHighMargin: homeDepotHighMargin,
        wfLowestModel: wfLowestModel,
        wfLowestPriceValue: wfLowestPriceValue,
        wfLowestPrice: wfLowestPrice,
        wfPriceValue: wfPriceValue,
        wfPrice: wfPrice,
        wfOurPriceValue: wfOurPriceValue,
        wfOurPrice: wfOurPrice,
        wfPremiumValue: wfPremiumValue,
        wfPremium: wfPremium,
        wayfairMarginValue: wayfairMarginValue,
        wayfairMarginLabel: wayfairMarginLabel,
        wayfairHighMargin: wayfairHighMargin,
        diffValue: diffValue,
        diff: diff,
        diffPercentageValue: diffPercentageValue,
        diffPercentage: diffPercentage,
      }
    },
    getOurPrice (item, prefix) {
      var data = JSON.parse(item[prefix + 'Data'])
      var wholesale = data[prefix + 'WholesalePrice']
      var promotion = data[prefix + 'PromotionPercentage']
      var ourPrice = null
      if (wholesale) {
        ourPrice = wholesale.price
        if (promotion) {
          if (promotion.percentage) {
            var percentage = promotion.percentage < 1 ? promotion.percentage : (promotion.percentage / 100)
            ourPrice = ourPrice * (1 - percentage)
          } else if (promotion.price > 0) {
            ourPrice = Math.min(ourPrice, promotion.price)
          }
        }
      } else {
        if (promotion && promotion.price) {
          ourPrice = promotion.price
        }
      }
      return ourPrice
    },
    changeSortOption (field) {
      this.sortOption = {
        field: field,
        asc: field == this.sortOption.field ? !this.sortOption.asc : false
      }
    },
    exportThisPage () {
      var headers = ['id', 'className', 'parentModel', 'model', 'hdLowestModel', 'hdLowestPrice', 'hdPrice', 'hdPremium',
        'wfLowestModel', 'wfLowestPrice', 'wfPrice', 'wfPremium', 'diff', 'diffPercentage'
      ]
      var rows = this.showingProducts.map(p => headers.map (h => (p[h] ? p[h] : '')).join(','))
      rows.unshift(headers.join(','))
      var string = rows.join('\r\n')
      var blob = new Blob([string], {type: 'text/plain;charset=utf-8'})
      var now = new Date()
      var today = dateFormat(now, 'yyyy-mm-dd')
      saveAs(blob, 'price_analysis_' + today + '.csv')
    },
  },
  mounted () {
    this.getProducts()
  },
}
</script>

<style scoped>
.table-container {
  max-height: calc(100vh - 80px);
  overflow: auto;

  table {
    text-align: left;
    position: relative;
  }

  th {
    background: white;
    position: sticky;
    top: 0;
  }
}
</style>
